"use client";

import clsx from "clsx";
import NextLink from "next/link";
import ArrowRight from "@/components/icon/arrow-right";
import AnimatedLink from "../animated-link";


export default function Cta({
  as = "button",
  className = "",
  href,
  label = "",
  onClick = () => {},
  children,
  disabled = false,
  ref,
  target = "_self",
  transitionName = "base",
  tabIndex,
  "aria-hidden": ariaHidden,
  hasArrow = false,
  inert = false,
}) {
  const classes = clsx(
    "flex items-center justify-center gap-[0.625rem] cta",
    hasArrow && "relative h-14 px-8 gap-x-3.5 text-[1rem]",
    className,
  );

  if (href) {
    // Use NextLink directly for external links (no view transition needed)
    if (target === "_blank") {
      return (
        <NextLink
          inert={inert}
          ref={ref}
          href={href}
          className={classes}
          onClick={onClick}
          aria-label={label}
          tabIndex={tabIndex}
          target={target}
          rel="noopener noreferrer"
        >
          {children}
          {hasArrow && (
            <ArrowRight className="cta-arrow h-auto w-4 [&_path]:stroke-current!" />
          )}
        </NextLink>
      );
    }

    return (
      <AnimatedLink
        inert={inert}
        ref={ref}
        disabled={disabled}
        href={href}
        className={classes}
        onClick={onClick}
        label={label}
        transitionName={transitionName}
        tabIndex={tabIndex}
        target={target}
      >
        {children}
        {hasArrow && (
          <ArrowRight className="cta-arrow h-auto w-4 [&_path]:stroke-current!" />
        )}
      </AnimatedLink>
    );
  }

  const Tag = as || "button";

  return (
    <Tag
      ref={ref}
      disabled={as === "button" ? disabled : undefined}
      inert={inert}
      className={classes}
      onClick={onClick}
      aria-label={label}
      aria-hidden={ariaHidden}
      tabIndex={ariaHidden ? -1 : tabIndex}
    >
      {children}
      {hasArrow && (
        <ArrowRight className="cta-arrow h-auto w-4 [&_path]:stroke-current!" />
      )}
    </Tag>
  );
}
